import { PropsWithChildren } from "react"

type Props = PropsWithChildren<{}>

export function SearchResultWidget(props: Props) {
  return <div className="search-result-item search-result-widget">{props.children}</div>
}
